var isCaptchaRequired = false;

function pulse (element) {
    $(element).fadeTo('slow', '.5', function () {
        $(element).fadeTo('slow', '1', function () {
            pulse(element);
        });
    });
}

/* MENU FUNCTIONS */
function closeModal (target) {

    $('div [target=' + target + ']').animate({
        'margin-top': -250,
        opacity: 0
    }, 250,
    function () {
        $('.pop_demo').fadeOut();
        $(this).hide();
    });

    _gaq.push(['_trackPageview', '/' + target + '/close']);

}

function showModal (target, cb) {

    var $target = ('demo' == target || 'signup' == target) ?
        $('div [target=' + target + ']') :
        (!$('[target=' + target + ']')[0] ?
            $('<div target=' + target + ' class="demo_req"><div class="demo_head"><a href="javascript://" class="close" onclick="closeModal(\'' + target + '\')">close</a></div><div class="demo_body _haj"></div></div>').appendTo('.pop_demo') :
            $('div [target=' + target + ']'));

    $('.pop_demo').fadeIn();

    if (target) {

        $target
            .show()
            .css({
                'margin-top': '-250px',
                'opacity': '0.1'
            })
            .animate({
                'margin-top': -300,
                opacity: 1
            }, 250, function () {
                if (0 > $(this).offset().top) { $target.css('top', 380); }
            }).css('top', $(window).height() / 2);

        if ('function' === typeof cb) { cb($target); }

        $('div [target=' + target + '] input:first').focus();

        _gaq.push(['_trackPageview', '/' + target + '/open']);

    }

}

function _status (NewStatus, Secs) {
    Secs = Secs || 5;
    NewStatus = NewStatus.indexOf('data-has-html-content') > -1 ? NewStatus : DOMPurify.sanitize(NewStatus);
    $('#_status').html(NewStatus).fadeIn(1000);
    clearStatus(Secs);
}

function clearStatus (Secs) {
    var Secs = Secs || 5;
    try {
        $(document).stopTime('hide');
        $(document).oneTime(Secs + 's', 'hide', function () {
            $('#_status').fadeOut(2000);
        });
    } catch (err) {
        $('#_status').fadeOut('slow');
    }
}

function LoginUser () {

    /* MISSING DETAILS */
    var $email = $('#email'),
        $password = $('#password'),
        $password_new = $('#password_new'),
        $password_new_retype = $('#password_new_retype'),
        email = $email.val().trim(),
        password = $password.val(),
        password_new = $password_new.val(),
        password_new_retype = $password_new_retype.val(),
        $facebook_id = $('#facebook_id').val(),
        pass = '#changepass' === window.location.hash ? true : false,
        $loading = $('.form-loading'),
        $responseMessage = $('#response-message'),
        captchaMessage = document.getElementById('captcha-message'),
        $company_id = $('#company_id'),
        params;

    captchaMessage.style.setProperty('display', 'none');
    $responseMessage.hide();
    $loading.hide();
    $password.removeClass('error-message');
    $email.removeClass('error-message');
    captchaMessage.parentElement.classList.remove('captcha-error');

    if (!email || !password) {
        $responseMessage.show().html(_s('Your username/email or password is incorrect. Please try again or click ') + '<a tabindex="0" href="' + _base_ + 'account/reset/request/">' + _s('Forgot Password') + '.</a>');
        announceResponseMessage(
            'Your username/email or password is incorrect. Please try again or click ' +
            '<a href="' + _base_ + 'account/reset/request/">Forgot Password</a>.');
        $email.addClass('error-message');
        $password.addClass('error-message');
        return false;
    }

    if (isCaptchaRequired && grecaptcha.getResponse().length === 0) {
        captchaMessage.style.setProperty('display', 'block');
        captchaMessage.parentElement.classList.add('captcha-error');
        return false;
    }

    if (pass) {
        $password_new.removeClass('error-message');
        $password_new_retype.removeClass('error-message');
        $responseMessage.addClass('change-password-error-message');
        if (!password_new) {
            $responseMessage.show().html(_s('New Password Required.'));
            $password_new.addClass('error-message');
            $password_new_retype.removeClass('error-message');
            return false;
        }
        if (!password_new_retype) {
            $responseMessage.show().html(_s('Password Confirmation Required.'));
            $password_new_retype.addClass('error-message');
            $password_new.removeClass('error-message');
            return false;
        }
        if (password_new !== password_new_retype) {
            $password_new.addClass('error-message');
            $password_new_retype.addClass('error-message');
            $responseMessage.show().html(_s('Password Mismatch.'));
            return false;
        }
        if (6 > password_new.length) {
            $password_new.addClass('error-message');
            $password_new_retype.addClass('error-message');
            $responseMessage.show().html(_s('At least 6 characters long.'));
            return false;
        } else if (password_new === password) {
            $password_new.addClass('error-message');
            $password_new_retype.addClass('error-message');
            $responseMessage.show().html(_s('It is same as old password.'));
            return false;
        }
    }

    /* SEND */
    $loading.show();

    //== delete token if any
    StorageService.localStorage.remove(getCsrfTokenName());
    //StorageService.cookie.deleteCookie('csrfToken');

    params = {
        Action: 'LoginUser',
        email: email,
        password: password,
        facebook_id: $facebook_id
    };

    if (isCaptchaRequired) {
        params['captcha'] = grecaptcha.getResponse();
    }

    if (pass) {
        params.password_new = password_new;
        params.password_new_retype = password_new_retype;
    }

    if ($company_id !== undefined) {
        params['company_id'] = $company_id.val();
    }

    $('button[name=login]').prop('disabled', true);
    $.post('/process/sales.php', params,
        function (data, status, request) {
            var success = 'Login Success. One second please..',
                incorrect = 'incorrect-login',
                captchaFailed = 'captcha-failed',
                notactivated = 'Account Not Activated Yet.',
                deactivated = 'Account De-Activated.',
                billingexp = 'Billing has expired on your account.',
                alreadyloggedin = 'Someone is already logged in, redirecting. One second please..',
                captchaDiv = document.getElementById('captcha-div'),
                isCaptchaFailed = data.indexOf(captchaFailed) >= 0,
                isCaptchaVisible = captchaDiv.style.getPropertyValue('display') === 'block',
                commonPassword = 'common-password',
                mfaCheck = 'user_for_mfa_check',
                multipleAccounts = 'multiple-accounts',
                unknownCompany = 'unknown-company';

            //StorageService.cookie.setCookie('csrfToken', request.getResponseHeader('x-csrf-token'));

            if (0 <= data.indexOf(alreadyloggedin)) {
                success = alreadyloggedin;
            }

            setTimeout(function () {
                if (0 <= data.indexOf(success)) {
                    success = _s('Login Success. One second please..');
                    announceResponseMessage('Login Success. One second please..');
                    $('#script_body').html(data.replace(success, ''));
                    $('#status_msg').html(success);
                    $('.lfoot button').hide();
                    $('.threeparty').hide();
                } else {
                    if (0 <= data.indexOf(incorrect)) {
                        data = JSON.parse(data);
                        $responseMessage.show().html(
                            _s('Your username/email or password is incorrect. Please try again or click ')
                            + '<a tabindex="0" href="' + _base_ + 'account/reset/request/">' + _s('Forgot Password') + '.</a>');
                        announceResponseMessage(
                            'Your username/email or password is incorrect. Please try again or click ' +
                            '<a href="' + _base_ + 'account/reset/request/">Forgot Password</a>.');
                        $email.addClass('error-message');
                        $password.addClass('error-message');
                        $loading.hide();
                    } else if (isCaptchaFailed) {
                        isCaptchaVisible && $responseMessage.show().html(_s('We couldn\'t verify captcha. Please try again.'));
                        $loading.hide();
                    } else if (0 <= data.indexOf(notactivated)) {
                        $loading.hide();
                        $responseMessage.show().html(_s(notactivated));
                    } else if (0 <= data.indexOf(deactivated)) {
                        $loading.hide();
                        $responseMessage.show().html(_s(deactivated));
                    } else if (0 <= data.indexOf(billingexp)) {
                        $loading.hide();
                        $responseMessage.show().html(_s(billingexp));
                    } else if (0 <= data.indexOf(commonPassword)) {
                        $loading.hide();
                        $responseMessage.show().html(_s('Your password isn\'t strong enough. Please avoid short passwords with sequential numbers'));
                    } else if (data.indexOf(mfaCheck) >= 0) {
                        $loading.hide();
                        $('#mfa-form').show();
                        $('#login-mfa-code').focus();
                        $('#mfa-bottom-div').show();
                        $('#error-recovery-code').hide();
                        $('#mfa-bottom-recovery-div').hide();
                        $('#LoginForm').hide();
                        $('#SSOLogin').hide();
                        $('.device-switcher').hide();
                    } else if (0 <= data.indexOf(multipleAccounts)) {
                        $loading.hide();

                        if (0 <= data.indexOf('companies')) {
                            companyChooseModal(JSON.parse(data));
                        } else {
                            $responseMessage.show().html(_s('Something went wrong, please try later to log in.'));
                        }
                    } else if (0 <= data.indexOf(unknownCompany)) {
                        $loading.hide();
                        $responseMessage.show().html(_s(JSON.parse(data).message));
                    } else {
                        $('#script_body').html(data);
                    }

                    isCaptchaRequired = data.hasOwnProperty('captchaRequired') ? data.captchaRequired : isCaptchaFailed;

                    if (isCaptchaRequired || isCaptchaFailed) {
                        captchaDiv.style.setProperty('display', 'block');
                        grecaptcha.reset();
                    } else {
                        captchaDiv.style.setProperty('display', 'none');
                    }
                }

                return false;
            }, 400);

            $('button[name=login]').prop('disabled', false);
        }
    );
    return false;
}
function mfaCheck(code) {
    $.post('/process/sales.php', {code: code, Action: 'MFACheck'}, function (data, status) {

        if (data === 'changepass') {
            try {
                if (window.opener && !window.opener.closed) {
                    window.opener.location.hash = '#changepass';
                    window.opener.location.reload();
                    window.close();
                } else {
                    window.location.hash = '#changepass';
                    window.location.reload();
                }
            } catch(err) {
                window.location.hash = '#changepass';
                window.location.reload();
            }
            return;
        }

        if (data === 'Code-OK') {
            window.location.href = '/app/';
        } else {
            alert(data);
            $('#verifyLoginCode').prop('disabled', false);
        }
    });
}
function toggleSSOLogin(toggle) {
    var $loginForm = $('#LoginForm'),
        $SSOForm = $('#SSOLogin'),
        $forgotPasswordLink = $('.device-switcher'),
        $email = $('#email');

    if (toggle){
        $loginForm.show();
        $SSOForm.hide();
        $forgotPasswordLink.show();
    } else {
        $loginForm.hide();
        $SSOForm.show();
        $forgotPasswordLink.hide();
    }
    $email.focus();
    return false;
}

function loginWithAdp() {
    $('.form-loading').show();
    $.ajax({
        url: '/api/v2/adp/info',
        type: 'GET',
        success: function (response) {
            $('.form-loading').hide();
            if (response.enabled === true) {
                window.location.href = response.url;
            } else {
                toggleSSOLogin(false);
            }
        },
        error: function () {
            $('.form-loading').hide();
            toggleSSOLogin(false);
        }
    });
}

function LoginWithSSO(){
    var $errorMessage = $('#domain_error'),
        $domainInput = $('#domain_name'),
        domainName = $domainInput.val(),
        error = false,
        baseUrl = Config.environmentDomain + '/includes/saml/';

    error = validateDomainName(domainName);

    if (!domainName){
        $errorMessage.attr('aria-live', 'assertive');
        $errorMessage.removeClass('hide').show();
        $errorMessage.focus();
        setTimeout(function () {
            $errorMessage.addClass('hide').hide();
            $domainInput.focus();
        }, 2000);
        return false;
    }
    if (error) {
        $errorMessage.attr('aria-live', 'assertive');
        $errorMessage.removeClass('hide').show();
        $errorMessage.focus();
        setTimeout(function () {
            $errorMessage.addClass('hide').hide();
            $domainInput.focus();
        }, 2000);
        return false;
    }
    $errorMessage.hide();
    window.location.href = 'https://' + domainName + baseUrl;
    return false;
}

function validateDomainName(name){
    return !(/^(?!\-)[a-zA-Z0-9._\-]+$/).test(name);
}

function RequestAccess () {
    var $fullname = $('#fullname').val().trim(),
        $email = $('#req_email').val().trim(),
        $sec_answer = $('#sec_answer').val().trim(),
        $sub = $('#subdomain').val(),
        $loading = $('.form-loading'),
        $requestStatusMsg=$('#req_status_msg');

    if (0 < $('#childs').length) {
        $sub = $('#childs').val();
    }

    $('.lbody label').hide();
    $('.lsec label').hide();


    if (!isValidEmail($email)) {
        $('#valid_req_email').show();
    }
    if (!$fullname) {
        $('#valid_fullname').show();
    }
    if ('0' == $sub) {
        $('#valid_location').show();
        return false;
    }
    if (!$sec_answer) {
        $('#valid_sec_answer').show();
    }
    if (!isValidEmail($email) || !$fullname || !$sec_answer || '0' == $sub) {
        return false;
    }

    $loading.show();
    $requestStatusMsg.html(_s('Processing'));
    $('.lsec').addClass('hide');
    $('.lfoot').addClass('hide');
    $.post('/process/sales.php', {
        Action: 'RequestAccess',
        email: $email,
        name: $fullname,
        sec_answer: $sec_answer,
        subdomain: $sub
    },
    function (data) {
        setTimeout(function () {
            switch (data) {
            case '1':
                $loading.hide();
                $requestStatusMsg.addClass('success');
                $requestStatusMsg.html(_s('Request sent'));
                break;
            case '-1':
                $requestStatusMsg.html(_s('Incorrect request'));
                break;
            case '-2':
                // $('.lbody').removeClass('loading');
                $loading.hide();
                $requestStatusMsg.html('');
                $('#valid_req_email_taken').show();
                $('.lsec').removeClass('hide');
                $('.lfoot').removeClass('hide');
                break;
            case '-3':
                // $('.lbody').removeClass('loading');
                $loading.hide();
                $requestStatusMsg.html('');
                $('#incorrect_sec_answer').show();
                $('.lsec').removeClass('hide');
                $('.lfoot').removeClass('hide');
                break;
            case '-99':
                // $('.lbody').removeClass('loading');
                $loading.hide();
                $requestStatusMsg.html('');
                $('#valid_subdomain').show();
                $('.lsec').removeClass('hide');
                $('.lfoot').removeClass('hide');
                break;
            default:
                break;
            }
        }, 400);
    }
    );

    return false;

}

function isValidEmail (str) {
    return (2 < str.lastIndexOf('.')) && (0 < str.indexOf('@'));
}

function SendMessage () {

    $('#submit').val(_s('Sending Message..')).attr('disabled', true);
    $('.Notice').html('');

    var err = 0;

    /* IS FORM COMPLETE */
    var Req = ['name', 'email', 'message', 'subject'];

    for (i in Req) {
        if (!$('#' + Req[i]).val()) {
            $('#' + Req[i] + '_').html(' *' + _s('Required')).show();
            err = 1;
        }
    }


    if (0 == err) {

        $.post('/process/sales.php', {
            Action: 'SendMessage',
            name: $('#name').val(),
            email: $('#email').val(),
            subject: $('#subject').val(),
            message: $('#message').val()
        },
        function (data) {

            $('#SendMessage').html(data);

        });
    } else {
        $('#SubmitButton').effect('shake', {
            times: 2
        }, 'fast').val('Send Message').attr('disabled', false);
    }

}

function GetCarriers () {
    $.getJSON('/sms', {
        country: $('#country').val()
    }, function (j) {
        var options = '';

        for (var i = 0; i < j.length; i++) {
            options += '<option value="' + j[i].id + '">' + DOMPurify.sanitize(j[i].network) + '</option>';
        }
        $('select#carrier').html(options);
    });
}

function SendSMS () {
    var Carrier = $('#carrier').val();
    var Number = $('#number').val();

    if (Carrier && 5 < Number.length) {
        $('#Results').load('/sms?carrier=' + DOMPurify.sanitize(Carrier) + '&number=' + DOMPurify.sanitize(Number)).show();
    } else {
        $('#Results').html(_s('<b class="red">Missing Details</b>. Please select a carrier and enter a phone number above.')).show();
    }
}

$(function () {
    $('#verifyLoginCode').on('click', function () {
        $('#verifyLoginCode').prop('disabled', true);
        var code = document.querySelector('#login-mfa-code').value;

        if (code.trim().length !== 6) {
            _status(_s('Code has to be 6 digits length.'));
            $('#verifyLoginCode').prop('disabled', false);
            return;
        }
        mfaCheck(code);
    });

    $('#login-mfa-code').keypress(function(e) {
        if (e.which === 13) {
            $('#verifyLoginCode').prop('disabled', true);
            var code = document.querySelector('#login-mfa-code').value;

            if (code.trim().length !== 6) {
                _status(_s('Code has to be 6 digits length.'));
                $('#verifyLoginCode').prop('disabled', false);
                return;
            }
            mfaCheck(code);
        }
    });

    $('#verifyRecoveryCode').on('click', function () {

        var code = document.querySelector('#login-recovery-code').value;

        if (code.trim().length === 0) {
            _status('Recovery code cannot be empty.');
            return;
        }

        $.post('/process/sales.php', {code: code, Action: 'LoginWithRecoveryCode'}, function (data, status) {

            if (data === 'changepass') {
                try {
                    if (window.opener && !window.opener.closed) {
                        window.opener.location.hash = '#changepass';
                        window.opener.location.reload();
                        window.close();
                    } else {
                        window.location.hash = '#changepass';
                        window.location.reload();
                    }
                } catch(err) {
                    window.location.hash = '#changepass';
                    window.location.reload();
                }
                return;
            }

            if (data === 'Code-OK') {
                $('#recovery-codes-form').hide();
                $('#login-recovery-code').val('');
                $('#error-recovery-code').hide();
                $('#recoveryInfoModal').show().css({ display: 'flex' });
                $('#mfa-bottom-recovery-div').hide();
            } else {
                $('#login-recovery-code').val('');
                $('#login-mfa-code').val('');
                $('#recovery-codes-form').hide();
                $('#mfa-bottom-recovery-div').hide();
                $('#error-recovery-code').show();
                $('#LoginForm').show();
                $('.device-switcher').show();
                document.getElementById('error-recovery-code').scrollIntoView({ behavior: 'smooth' });
            }
        });
    });

    $('#confirmRecovery').on('click', function () {
        window.location.href = '/app/';
    });

    $('#mfa-cancelIcon').on('click', function () {
        $('#error-recovery-code').hide();
    });
    /* sso login prepopulate input with domain name */
    if (_domainName_ && _domainName_ !== 'www') {
        $('#domain_name').val(_domainName_);
    }

    if (0 < $('section.sticky').length) {
        var eOf = $('#menu-new').offset().top;

        $(window).on('scroll', function (e) {
            if ($(window).scrollTop() >= eOf) {
                $('section.sticky').show();
            } else {
                $('section.sticky').hide();
            }
        });
    }
    /* secure page slider*/
    $('#show-key.readmore').on('click', function (e) {
        e.preventDefault();
        $('#show-key.readmore').addClass('readless').removeClass('readmore').text(_s('Show Less Questions'));
        $('#show-key').css('background', 'url(' + _images_ + 'security/arrow-up.png' + ') no-repeat 10px 19px');
        $('ul.learnmore > li.moreInfo').stop(true, true).show(1000);
        $('.faq_items .mask').stop(true, true).fadeOut(500);
    });

    $('#show-key.readless').on('click', function (e) {
        e.preventDefault();
        $('#show-key.readless').addClass('readmore').removeClass('readless').text(_s('Show More Questions'));
        $('#show-key').css('background', 'url(' + _images_ + 'security/arrow-down.png' + ') no-repeat 10px 19px');
        $('ul.learnmore > li.moreInfo').stop(true, true).hide(1000);
        $('.faq_items .mask').stop(true, true).fadeIn(500);
    });
    /**/

    /* job-board job's filter*/
    var $filterType = $('#filterOptions li.active a').attr('class'),
        $holder = $('ul.ourHolder'),
        $data = $holder.clone();

    $('#filterOptions li a').click(function (e) {
        $('#filterOptions li').removeClass('active');

        var $filterType = $(this).attr('class');

        $(this).parent().addClass('active');
        if ('all' == $filterType) {
            var $filteredData = $data.find('li');
        } else {
            var $filteredData = $data.find('li[data-type=' + $filterType + ']');
        }

        return false;
    });
    /**/

    $('#content-center .readmore').on('click', function (e) {
        e.preventDefault();
        $('#content-center .readmore').addClass('readless').removeClass('readmore').text(_s('Show less'));
        $('ul.learnmore > li.moreInfo').show(1000);
        $('.moreInfo.bottom').show(1000);
        $('#content-center .mask').fadeOut(1000);
        $('#content-listings2 .mask').fadeOut(1000);

    });
    $('#content-center .readless').on('click', function (e) {
        e.preventDefault();
        $('#content-center .readless').addClass('readmore').removeClass('readless').text(_s('Show more'));
        $('#content-center .mask').fadeIn(1000);
        $('#content-listings2 .mask').fadeIn(1000);
        $('ul.learnmore > li.moreInfo').hide(1000);
        $('.moreInfo.bottom').fadeIn(500).hide(100);
    });

    /* DEMO REGISTER */

    $('.demo_body input').css('width', '290px');
    $('#inLogin input');

    $('#_left').mouseover(function () {
        $('.intro_txt span').removeClass('_right').addClass('_left');
        $('.intro_txt div').text(_s('Connect with a Humanity Team Member for a live demo right now!'));
    });
    $('#_right').mouseover(function () {
        $('.intro_txt span').removeClass('_left').addClass('_right');
        $('.intro_txt div').text(_s('Connect with a Humanity Team Member for a scheduled demo!'));
    });

    $('#mt_ename').alphanumeric({
        allow: '-.@_+'
    }).focus();
    $('#mt_name').alphanumeric({
        allow: '-. '
    }).focus();
    $('#mt_phone').numeric({
        allow: '-+()'
    });
    $('#mt_business').alphanumeric({
        allow: '-. '
    }).on('blur', function () {

        if (!$('#mt_domain').val() || $('#mt_domain').val() == $('#mt_domain').prop('defaultValue')) {

            $('#mt_domain').val($('#mt_business').val());
            ModalDomainClean();
            ModalDomainTrail();
        }

    });

    $('#mt_domain').alphanumeric({
        allow: '-'
    }).on('keyup keydown', function () {

        ModalDomainClean();

        var string = this.value;

        if (0 < string.length && $(this).val() != $(this).prop('defaultValue')) {
            ModalDomainTrail();
        } else {
            $('#domaintrail').html('');
        }

    });


    /* LANGUAGE */

    $('.pop_cont .popClose').click(function () {
        $('.pop_cont').fadeOut(500);
    });

    $('.langChooser').click(function () {
        $('.pop_cont').fadeIn(500);
    });

    $('.langSugDontShow').click(function (e) {
        e.preventDefault();
        var exdate = new Date();

        exdate.setDate(exdate.getDate() + 365);
        document.cookie = 'doNotShowLanguageSuggestion=1; expires=' + exdate.toUTCString();
        $('.langSug').hide(500);
    });

    $('.langMachineDontShow').click(function (e) {
        e.preventDefault();
        var mexdate = new Date();

        mexdate.setDate(mexdate.getDate() + 365);
        document.cookie = 'doNotShowMachineSuggestion=1; expires=' + mexdate.toUTCString();
        $('.langSug').hide(500);
    });

    $('html:lang(sq) .langChooser').html('Shqip');
    $('html:lang(en) .langChooser').html('English');
    $('html:lang(be) .langChooser').html('Беларуская мова');
    $('html:lang(bg) .langChooser').html('Български');
    $('html:lang(ca) .langChooser').html('Català');
    $('html:lang(cn) .langChooser').html('繁体字');
    $('html:lang(tw) .langChooser').html('繁體字');
    $('html:lang(hr) .langChooser').html('Hrvatski');
    $('html:lang(cs) .langChooser').html('Čeština');
    $('html:lang(da) .langChooser').html('Dansk');
    $('html:lang(nl) .langChooser').html('Nederlands');
    $('html:lang(et) .langChooser').html('Eesti keel');
    $('html:lang(tl) .langChooser').html('Filipino');
    $('html:lang(fi) .langChooser').html('Suomi');
    $('html:lang(fr) .langChooser').html('Français Canadien');
    $('html:lang(ff) .langChooser').html('Français');
    $('html:lang(ka) .langChooser').html('ქართული');
    $('html:lang(de) .langChooser').html('Deutsch');
    $('html:lang(hu) .langChooser').html('Magyar');
    $('html:lang(is) .langChooser').html('Íslenska');
    $('html:lang(ga) .langChooser').html('Gaeilge');
    $('html:lang(it) .langChooser').html('Italiano');
    $('html:lang(ja) .langChooser').html('日本語');
    $('html:lang(ko) .langChooser').html('韓國語');
    $('html:lang(lv) .langChooser').html('Latviešu valoda');
    $('html:lang(lt) .langChooser').html('Lietuvių kalba');
    $('html:lang(mk) .langChooser').html('Македонски');
    $('html:lang(ms) .langChooser').html('Bahasa melayu');
    $('html:lang(mt) .langChooser').html('Malti');
    $('html:lang(no) .langChooser').html('Norsk');
    $('html:lang(pl) .langChooser').html('Polski');
    $('html:lang(pt) .langChooser').html('Português');
    $('html:lang(ro) .langChooser').html('Român');
    $('html:lang(ru) .langChooser').html('Русский');
    $('html:lang(sr) .langChooser').html('Српски');
    $('html:lang(sk) .langChooser').html('Slovenčina');
    $('html:lang(sl) .langChooser').html('Slovenščina');
    $('html:lang(es) .langChooser').html('Español');
    $('html:lang(sv) .langChooser').html('Svenska');
    $('html:lang(th) .langChooser').html('ภาษาไทย');
    $('html:lang(tr) .langChooser').html('Türkçe');
    $('html:lang(uk) .langChooser').html('Українська');
    $('html:lang(vi) .langChooser').html('Tiếng việt');
    $('html:lang(cy) .langChooser').html('Cymraeg');
    $('html:lang(ar) .langChooser').html('العربية');
});

/* REGISTER */

function getCookie (name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];

        while (' ' == c.charAt(0)) {
            c = c.substring(1, c.length);
        }
        if (0 == c.indexOf(nameEQ)) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return '';
}

function ModalDomainTrail () {
    adjustwidth = $('#ghosttrail').html($('#mt_domain').val()).width();
    var adjust = 0;

    if (1 == $('.trial').length) {
        adjustwidth -= 28;
        adjust = 100;
    } else {
        $('#domaintrail').css('top', '-39px');
    }
    $('#domaintrail').css({
        'margin-left': (adjustwidth + 38) + 'px'
    }).html(_cookieDomain_);
    if (221 < (adjustwidth + 38 + adjust)) {
        $('#domaintrail').fadeOut();
    } else {
        $('#domaintrail').fadeIn();
    }
}

function ModalDomainClean () {

    var Domain = $('#mt_domain').val();

    Domain = Domain.split(' ').join('');
    Domain = Domain.toLowerCase();
    Domain = Domain.replace(/[^a-zA-Z 0-9]+/g, '');

    $('#mt_domain').val(Domain);
}

function isValidPhone (phonenumber) {
    if ('' != phonenumber) {
        var goodChars = '+- 1234567890()';

        for (i = 0; i < phonenumber.length; i++) {
            var c = phonenumber.charAt(i);

            if (0 > goodChars.indexOf(c)) { return false; }
        }

        if (9 > phonenumber.length) { return false; }

        return true;

    }

    return false;
}

function initializeCaptcha() {
    var captchaDiv = document.getElementById('captcha-div');

    if (!captchaDiv) return;

    captchaDiv.style.setProperty('display', 'none');

    grecaptcha.render('captcha-div', {
        'sitekey': Config.reCaptchaKey
    });
}

function companyChooseModal(jsonData) {
    var modalHtml = '<div id="chooseCompanyModal" class="login">';

    modalHtml += '<div class="overlay"></div>';

    modalHtml += '<div class="cnt">';
    modalHtml += '<div class="leftArrowContainer" onclick="closeModalDialog();"><img class="leftArrow" src="/app/layout/images/icon/arrowLeftIcon.svg" alt="noIcon" /></div>';
    modalHtml += '<h3 class="modalTitle">' + _s('Please select which account you would like to log in:') + '</h3><br/>';
    modalHtml += '<div class="multipleAccountContainer"><img class="multipleAccount" src="/app/layout/images/icon/multipleAccountIcon.svg" alt="noIcon" /></div>';
    modalHtml += '<div class="companyList">';
    for (company in jsonData.companies) {
        modalHtml += '<div class="companyItem" onclick="logInUnderCompany(' + jsonData.companies[company].companyId + ');">' + jsonData.companies[company].companyName + '<img class="rightArrow" src="/app/layout/images/icon/rightArrowIcon.png" alt="noIcon" /></div>';
    }
    modalHtml += '</div>';
    modalHtml += '</div>';

    modalHtml += '</div>';

    $('#login').parent().parent().append(modalHtml);
    $(window).trigger('resize');
}

function closeModalDialog () {
    $('#chooseCompanyModal').remove();
}

function logInUnderCompany(companyId) {
    loginForm = $('#LoginForm');
    loginForm.append(
        '<input id="company_id" type="hidden" name="company_id" value="' + companyId + '">'
    );
    closeModalDialog();

    $('button[name=login]').click();
}

function announceResponseMessage (htmlMessage) {
    var $responseMessage = $('#response-message');
    
    $responseMessage.html('');
    setTimeout(function () {
        $responseMessage.html(htmlMessage);
        $responseMessage.focus();
    }, 100);
}
